<template>
  <div class="narrative">
    <NarrativeBlock
      :step="currentStep"
      :first="currentStep.index === 0"
      :last="currentStep.index === steps.length - 1"
      :progress="currentProgress"
      :total="steps.length"
      @exitNarrative="exitNarrative"
      v-if="!movingToStart"
    />
  </div>
</template>

<script>
import NarrativeBlock from "../components/NarrativeBlock";
import { steps, initialLocation, endLocation } from "../constants/narrative.js";
import { DEFAULT_LOCATION, DEFAULT_YEAR } from "@/constants/constants";
import { getScrollDistance } from "../constants/scroll";
import { setNarrativeComplete } from "../localStorage";

export default {
  name: "NarrativeView",
  components: {
    NarrativeBlock
  },
  mounted() {
    window.addEventListener("wheel", this.scrollwheel);
    this.$store.commit("setFlip", { flip: false });
    if (
      Math.abs(this.$store.state.geolocation.location - initialLocation) > 0.003
    ) {
      this.$store.dispatch("goToLocation", { target: initialLocation });
      this.movingToStart = true;
      window.setTimeout(() => {
        this.movingToStart = false;
      }, 3000);
    } else {
      this.movingToStart = false;
    }

    this.$store.commit("setYearOverride", "1966");
    this.loadStep(this.currentStep);
  },
  beforeDestroy() {
    this.$store.dispatch("setMode", "normal");
    window.removeEventListener("wheel", this.scrollwheel);
    this.$store.commit("setYearOverride", false);
    this.$store.commit("resetTour");
  },
  data() {
    return {
      accelerating: 0,
      direction: 1,
      flipped: false,
      movingToStart: true
    };
  },
  methods: {
    scrollwheel(e) {
      let scrollAmount = getScrollDistance(e);
      if (this.$store.state.geolocation.flipped) scrollAmount *= -1;

      this.$store.commit("setDirection", scrollAmount >= 0 ? 1 : -1);

      let newLocation = this.$store.state.geolocation.location + scrollAmount;

      if (newLocation < endLocation) {
        this.exitNarrative();
      }
      this.$store.commit("setLocation", Math.min(initialLocation, newLocation));
    },

    exitNarrative() {
      this.$store.dispatch("setMode", "normal");
      this.$router.push({
        name: "map",
        params: { year: DEFAULT_YEAR + "" }
      });
      this.$store.commit("setLocation", DEFAULT_LOCATION);
      this.$store.commit("setYearOverride", false);
      this.$store.commit("resetTour");
      setNarrativeComplete(true);
    },

    loadStep(step) {
      if (step.mode) {
        this.$store.dispatch("setMode", step.mode);
      }

      if (step.year) {
        this.$store.commit("setYearOverride", step.year);
      }

      if (step.flip) {
        this.$store.commit("setFlip", { flip: true, demo: false });
        window.setTimeout(() => {
          this.$store.commit("setFlip", { flip: false, demo: false });
        }, 1250);
      }
    }
  },
  computed: {
    currentStep() {
      for (let i = 0; i < this.steps.length; i++) {
        if (
          (this.position <= this.steps[i].start || i === 0) &&
          this.position > this.steps[i].end
        ) {
          return { ...this.steps[i], index: i };
        }
      }

      return {
        ...this.steps[this.steps.length - 1],
        index: this.steps.length - 1
      };
    },
    currentIndex() {
      return this.currentStep.index;
    },
    steps() {
      return steps;
    },
    position() {
      return this.$store.state.geolocation.location;
    },
    currentProgress() {
      let p =
        1 +
        (this.position - this.currentStep.end) /
          (this.currentStep.end - this.currentStep.start);

      return p;
    }
  },
  watch: {
    currentIndex(to) {
      this.loadStep(this.steps[to]);
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/constants/_variables.scss";

.map-container {
  height: 100%;
  width: 100%;
}

.map-view {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  transition: 1s transform;
}

.map {
  width: 100%;
  height: 20%;
}

.canvas {
  width: 100%;
  height: 40%;
}

.truck {
  position: absolute;
  width: 150px;
  z-index: 50;
  top: calc(50% - 57px + 15px);
  left: calc(50% - 75px);
  pointer-events: all;
}
</style>
